// Vendor
import { ElementRef } from '@angular/core';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { UtilsService } from 'NewAngular/services/core/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
import * as i3 from "NewAngular/services/core/utils.service";
import * as i4 from "@angular/common";
const _c0 = ["copiedText"];
const _c1 = a0 => ({ "opacity": a0 });
function ApiKeyManagerComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "a", 9);
    i0.ɵɵlistener("click", function ApiKeyManagerComponent_div_0_div_6_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.copy()); });
    i0.ɵɵelementStart(2, "strong", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 11)(5, "span");
    i0.ɵɵtext(6, " Copied! ");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.apiKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.hideCopiedText);
} }
function ApiKeyManagerComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.error, " ");
} }
function ApiKeyManagerComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "br");
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵlistener("click", function ApiKeyManagerComponent_div_0_div_8_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.regenerateApiKey()); });
    i0.ɵɵtext(3, "Get New API Key");
    i0.ɵɵelementEnd()();
} }
function ApiKeyManagerComponent_div_0_div_9_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "p");
    i0.ɵɵtext(2, "All YCharts API requests are made over SSL using a http ");
    i0.ɵɵelementStart(3, "code");
    i0.ɵɵtext(4, "GET");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " method. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7, "Example curl request:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div")(9, "code");
    i0.ɵɵtext(10, "curl -H \\");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "br");
    i0.ɵɵelementStart(12, "code");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "br");
    i0.ɵɵelementStart(15, "code");
    i0.ɵɵtext(16, "https://api.ycharts.com/v3/companies?exchange=NYSE");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(13);
    i0.ɵɵtextInterpolate1("\"X-YCHARTSAUTHORIZATION: ", ctx_r1.apiKey, "\" \\");
} }
function ApiKeyManagerComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 4);
    i0.ɵɵtext(2, " Your YCharts API Key must be included in all requests to the API using the header key: ");
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "code");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, ApiKeyManagerComponent_div_0_div_9_div_6_Template, 17, 1, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("X-YCHARTSAUTHORIZATION: ", ctx_r1.apiKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.includeExample);
} }
function ApiKeyManagerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "p")(3, "strong");
    i0.ɵɵtext(4, "Access Key:\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, ApiKeyManagerComponent_div_0_div_6_Template, 7, 2, "div", 6)(7, ApiKeyManagerComponent_div_0_div_7_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ApiKeyManagerComponent_div_0_div_8_Template, 4, 0, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ApiKeyManagerComponent_div_0_div_9_Template, 7, 2, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngSwitch", !!ctx_r1.error);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.page === "api");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.error && ctx_r1.page === "api");
} }
function ApiKeyManagerComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "a", 27);
    i0.ɵɵlistener("click", function ApiKeyManagerComponent_div_1_div_6_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.copy()); });
    i0.ɵɵelementStart(2, "strong", 28);
    i0.ɵɵlistener("mouseover", function ApiKeyManagerComponent_div_1_div_6_Template_strong_mouseover_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.changeHover(true)); })("mouseleave", function ApiKeyManagerComponent_div_1_div_6_Template_strong_mouseleave_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.changeHover(false)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "p", 29, 0);
    i0.ɵɵtext(6, " Copied! ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.hover ? "text-black" : "text-blue");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.apiKey, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.hideCopiedText)("ngStyle", i0.ɵɵpureFunction1(4, _c1, ctx_r1.copiedTextOpacity));
} }
function ApiKeyManagerComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.error);
} }
function ApiKeyManagerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵtext(2, "Excel Add-in Access Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 18)(4, "div", 19);
    i0.ɵɵtext(5, "Access Key:");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ApiKeyManagerComponent_div_1_div_6_Template, 7, 6, "div", 20)(7, ApiKeyManagerComponent_div_1_div_7_Template, 3, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 22)(9, "div", 23)(10, "div", 24);
    i0.ɵɵlistener("click", function ApiKeyManagerComponent_div_1_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.regenerateApiKey()); });
    i0.ɵɵtext(11, " Get New API Key ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "a", 25);
    i0.ɵɵtext(13, "Visit Excel Add-in Download Center");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !ctx_r1.error);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.error);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("href", ctx_r1.excelLink, i0.ɵɵsanitizeUrl);
} }
export class ApiKeyManagerComponent {
    constructor(ajaxService, eltRef, urlsService, utilsService) {
        this.ajaxService = ajaxService;
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.utilsService = utilsService;
        this.apiKey = ''; // pragma: allowlist secret
        this.error = '';
        this.excelLink = '';
        this.includeExample = true;
        this.hover = false;
        this.hideCopiedText = true;
        this.copiedTextOpacity = 1;
        this.hasFeature = this.eltRef.nativeElement.getAttribute('hasFeature') === 'True';
        this.page = this.eltRef.nativeElement.getAttribute('page');
        this.includeExample = this.eltRef.nativeElement.getAttribute('includeExample') !== 'False';
        this.excelLink = this.urlsService.EXCEL.EXCEL_CENTER;
    }
    ngOnInit() {
        if (this.page === 'settings' && !this.hasFeature)
            return;
        this.getApiKey();
    }
    getApiKey() {
        const apiUrl = this.urlsService.API.API_KEY;
        this.ajaxService.getDataObserveBody(apiUrl).subscribe({
            next: (res) => {
                this.apiKey = res.app_key; // pragma: allowlist secret
                this.error = '';
                this.hasFeature = true;
            },
            error: (res) => {
                if (res.status === 403) {
                    this.error = 'You do not have access to this feature.';
                    this.hasFeature = false;
                }
                else if (res.status === 404) {
                    this.error = 'No access key exists. Click below to generate one.';
                    this.hasFeature = true;
                }
                else {
                    this.error = 'Unknown error, Please try again or contact customer support.';
                    this.hasFeature = true;
                }
            },
        });
    }
    regenerateApiKey() {
        this.ajaxService.postJsonDataObserveResponse(this.urlsService.API.API_KEY, {}).subscribe({
            next: () => this.getApiKey(),
            error: (res) => {
                if (res.status === 403) {
                    this.error = 'You do not have access to this feature.';
                    this.hasFeature = false;
                }
                else {
                    this.error = 'Unknown error, Please try again or contact customer support.';
                    this.hasFeature = true;
                }
            },
        });
    }
    copy() {
        this.utilsService.copyToClipboard(this.apiKey);
        this.hideCopiedText = false;
        let timer = 150;
        const intervalId = setInterval(() => {
            if (timer <= 0) {
                this.hideCopiedText = true;
                this.copiedTextOpacity = 1;
                clearInterval(intervalId);
            }
            else if (timer < 75) {
                this.copiedTextOpacity -= 0.1;
            }
            timer -= 1;
        }, 15);
    }
    changeHover(hover) {
        this.hover = hover;
    }
}
ApiKeyManagerComponent.ɵfac = function ApiKeyManagerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ApiKeyManagerComponent)(i0.ɵɵdirectiveInject(i1.AjaxService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.UrlsService), i0.ɵɵdirectiveInject(i3.UtilsService)); };
ApiKeyManagerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ApiKeyManagerComponent, selectors: [["ycn-api-key-manager"]], viewQuery: function ApiKeyManagerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.copiedText = _t.first);
    } }, standalone: false, decls: 2, vars: 2, consts: [["copiedText", ""], ["class", "public-list", "data-test-id", "API Display", 4, "ngIf"], ["class", "topics-section", "data-test-id", "Settings Display", 4, "ngIf"], ["data-test-id", "API Display", 1, "public-list"], [1, "public-list-item"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["data-test-id", "API | Error Display", 4, "ngSwitchCase"], [4, "ngIf"], ["href", "javascript:void(0)", "data-test-id", "API | Key Display", 3, "click"], [1, "text-green"], [1, "text-blue", 2, "display", "inline", 3, "hidden"], ["data-test-id", "API | Error Display"], ["href", "", "data-test-id", "API | Generate Button", 1, "btn", "btn-primary", 2, "opacity", "1", "float", "none", 3, "click"], ["data-test-id", "api-key-example", "class", "public-list-item", 4, "ngIf"], ["data-test-id", "api-key-example", 1, "public-list-item"], ["data-test-id", "Settings Display", 1, "topics-section"], [1, "topics-section-header"], [1, "form-row"], [1, "form-label", "form-label-thin"], ["class", "form-control-plaintext public-intro", 4, "ngIf"], ["class", "form-control-plaintext public-intro", "data-test-id", "Settings | Error Display", 4, "ngIf"], [1, "row", "form-row"], [1, "col-i-md-2"], ["data-test-id", "Settings | Generate Button", 1, "btn", "btn-outline", "btn-ghost", "btn-support", "btn-full-width", 3, "click"], [1, "public-intro", "text-blue", 3, "href"], [1, "form-control-plaintext", "public-intro"], ["href", "javascript:void(0)", "data-test-id", "Settings | Key Display", 3, "click"], [3, "mouseover", "mouseleave", "ngClass"], [1, "text-green", "text-small", 3, "hidden", "ngStyle"], ["data-test-id", "Settings | Error Display", 1, "form-control-plaintext", "public-intro"]], template: function ApiKeyManagerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ApiKeyManagerComponent_div_0_Template, 10, 5, "div", 1)(1, ApiKeyManagerComponent_div_1_Template, 14, 3, "div", 2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.page !== "settings");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.page === "settings" && ctx.hasFeature === true);
    } }, dependencies: [i4.NgClass, i4.NgIf, i4.NgStyle, i4.NgSwitch, i4.NgSwitchCase], encapsulation: 2 });
